import React from 'react'
import Loading from "react-fullscreen-loading";

const Loader = (props) => {
  return (
    <Loading loading={props.isLoading} background="#00000033" loaderColor="#1976d2" />
  )
}

export default Loader